module.exports = __webpack_public_path__ + "static/media/sharecard-money.18181992.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sharecard-money.png
// module id = 594
// module chunks = 4